/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Tiktok24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="TikTok 24">
      <g className="SVG" clipPath="url(#a)">
        <path
          fill="#0E0E0E"
          d="M17.334 4.927a4.808 4.808 0 0 1-1.188-3.173h-.93a4.821 4.821 0 0 0 2.118 3.173ZM8.73 11.78a2.925 2.925 0 0 0-2.92 2.923c0 1.123.638 2.1 1.568 2.59a2.894 2.894 0 0 1-.554-1.707 2.925 2.925 0 0 1 2.921-2.923c.3 0 .592.051.864.136V9.246a6.496 6.496 0 0 0-.864-.061c-.052 0-.099.004-.15.004v2.726a2.94 2.94 0 0 0-.864-.136Z"
          className="Vector"
        />
        <path
          fill="#0E0E0E"
          d="M19.969 6.487v2.702a8.272 8.272 0 0 1-4.838-1.556v7.074c0 3.53-2.869 6.407-6.4 6.407a6.373 6.373 0 0 1-3.668-1.161 6.39 6.39 0 0 0 4.682 2.044c3.527 0 6.401-2.872 6.401-6.406V8.517a8.271 8.271 0 0 0 4.837 1.556V6.595c-.352 0-.69-.038-1.014-.108Z"
          className="Vector"
        />
        <path
          fill="#0E0E0E"
          d="M15.132 14.708V7.634a8.272 8.272 0 0 0 4.837 1.556V6.487a4.831 4.831 0 0 1-2.635-1.56 4.86 4.86 0 0 1-2.123-3.173h-2.545l-.005 13.945a2.925 2.925 0 0 1-2.916 2.816 2.934 2.934 0 0 1-2.372-1.217 2.934 2.934 0 0 1-1.568-2.59 2.925 2.925 0 0 1 2.92-2.924c.301 0 .593.052.865.136V9.195c-3.456.076-6.246 2.914-6.246 6.397 0 1.683.653 3.215 1.719 4.362a6.373 6.373 0 0 0 3.668 1.161c3.527 0 6.4-2.876 6.4-6.406Z"
          className="Vector"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a" className="a">
        <path fill="#fff" d="M3 1.5h18v21H3z" />
      </clipPath>
    </defs>
  </svg>
);

const SIZE_MAP = {
  sm: Tiktok24,
  md: Tiktok24,
  lg: Tiktok24,
  xl: Tiktok24,
  xxl: Tiktok24,
  xxxl: Tiktok24,
};

export const TiktokIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'tiktok-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
